import { render, staticRenderFns } from "./DetalheOfertaView.vue?vue&type=template&id=076d9650"
import script from "./DetalheOfertaView.vue?vue&type=script&lang=js"
export * from "./DetalheOfertaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports